import { Component } from '@angular/core';
import { AlertController ,NavController} from 'ionic-angular';
import {datos} from '../../providers/datos';
import {lista} from '../lista/lista';
import { Detalle } from '../detalle/detalle';
import { Login } from '../login/login';

import { ModalController, NavParams } from 'ionic-angular';
declare var swal: any;


@Component({
  templateUrl: 'servicios_ocre.html',
  selector: 'servicios_ocre',
  providers: []
})

export class servicios_ocre {


  //items=[];

  items= [
    {
        "id": 1,
        "title": "Manos",
        "subtitle": "uñas acrilias, cortes, decoraciones...",
        "image": "assets/images/servicios/manos.jpg",
        "items":[
          {
            id:"1",
            nombre:"Manicurado",
            cantidad:1,
            valor:4.66,
            fecha:"27/08/2018",
            hora:"23:44"
          },
          {
            id:"2",
            nombre:"tints",
            des:"",
            cantidad:1,
            valor:4.66,
            fecha:"27/08/2018",
            hora:"23:44"
          },
          {
            id:"3",
            nombre:"uñasss",
            cantidad:1,
            des:"",
            valor:4.66,
            fecha:"27/08/2018",
            hora:"23:44"
          }
        ]       

    }


];

  // services: array
  constructor(
    private datos:datos,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public navCtrl: NavController
  ) {

    // this.navCtrl.push(Login);
    this.iniciar();

  }



  calificar(){
    let wrap = document.createElement('div');
    wrap.setAttribute('class', 'text-muted');
    wrap.innerHTML = '<button clear onclick="reply(\'sad\')" type="button" value="sad" class="btn feel"><i class="fa fa-frown-o fa-3x"></i></button><button onclick="reply(\'neutral\')" type="button" value="neutral" class="btn feel"><i class="fa fa-meh-o fa-3x"></i></button><button onclick="reply(\'happy\')" type="button" value="happy" class="btn feel"><i class="fa fa-smile-o fa-3x"></i></button><hr>'
    
    swal({
      title: "",
      text: "Cómo fue atendido por el especialista?",
      icon: "info",
      className: '',
      closeOnClickOutside: false,
      content: {
        element: wrap
      },
      buttons: {
        confirm: {
          text: "OK",
          value: '',
          visible: true,
          className: "btn btn-default",
          closeModal: true,
        }
      },
    }).then((value) => {
      if (value === 'sad') {
        swal("Sorry!", {
          icon: "error",
          buttons: false
        });
      } else if (value === 'neutral') {
        swal("Okay!", {
          icon: "warning",
          buttons: false
        });
      } else if (value === 'happy') {
        swal("Hooray!", {
          icon: "success",
          buttons: false
        });
      }
    });

  }


  openLista(items) {
    // let profileModal = this.modalCtrl.create(lista, { userId: 8675309 });
    // profileModal.present();

    this.navCtrl.push(lista,{ "items":items })
    
  }
 

  carrito() {
    
    this.navCtrl.push(Detalle,{ });
    
  }
 


  selectPageForOpen(value: string): any {
    let page;

    switch (value) {

      case "imageGallery":
        page = "ItemDetailsPageImageGallery";
        break;

        default:
        page = "ItemDetailsPage";
    }

    return page;
  }

  getMenu(lista2){

    console.log(lista2);
    for (let i= 0; i<lista2.length; i++) {
      setTimeout(() => {
        this.items.push(lista2[i]);

      }, 500*i);

    }
  }




  iniciar()
  {
    this.datos.loader(1);
    this.datos.getPagina('app/getServicios')
               .subscribe((data) => {
                         this.datos.loader(0);
                        this.getMenu(data.data);
                },
               (error: any) => {
                   console.log(error);
                   this.datos.loader(0);

                  //  setTimeout(() => {
                    //  this.iniciar();
                  //  }, 3000);
               });
               return 0
  }



  
  openPage(page: any) {


  }

  navigation(page: any) {


  }

  showPrompt() {

}
}



// WEBPACK FOOTER //
// ./src/pages/servicios_ocre/servicios_ocre.ts